import { render, staticRenderFns } from "./InterestedCard.vue?vue&type=template&id=034cab66&scoped=true&"
import script from "./InterestedCard.vue?vue&type=script&lang=js&"
export * from "./InterestedCard.vue?vue&type=script&lang=js&"
import style0 from "./InterestedCard.vue?vue&type=style&index=0&id=034cab66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034cab66",
  null
  
)

export default component.exports